import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { memo } from "react";

export function IconWithText({ txt: text, IconComponent, iconProps, textProps }) {
  return (
    <div
      style={{
        position: "relative",
      }}>
      <Typography
        variant="caption"
        style={{
          position: "absolute",
          top: 20,
          left: -20,
          opacity: 0.7,
          width: 65,
        }}
        {...textProps}>
        {text}
      </Typography>
      <div>
        <IconComponent />
      </div>
    </div>
  );
}

IconWithText.propTypes = {
  disabled: PropTypes.bool,
  txt: PropTypes.string,
  IconComponent: PropTypes.elementType,
  iconProps: PropTypes.object,
  textProps: PropTypes.object,
};

export default memo(IconWithText);
